import { Col, Row } from "react-bootstrap";
import leetlogo from "../../Assets/Abouts/Leetcode-img.png";
import hack from "../../Assets/Abouts/hack.png";
import github from "../../Assets/Abouts/github.png";
import ProjectCard from "./ProjectCards";
import gfg from "../../Assets/Abouts/gfg.jpeg";
import unstop from "../../Assets/Abouts/unstop.png";

function CodingPlateform() {
  

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px", }}>
      <Col md={4} className="project-card">
        <ProjectCard 
        //   imgPath={leet}
          logo = {leetlogo}
          isBlog={false}
          title="LeetCode"
          description=""
          leetcodeLink="https://leetcode.com/arpit-sharma"
        />
      </Col>
      

      <Col md={4} className="project-card">
        <ProjectCard
        //   imgPath={linkedinpro}
          isBlog={false}
          logo = {gfg}
          title="GeeksforGeeks"
          description=""
          leetcodeLink="https://www.geeksforgeeks.org/profile/arpitsharma6074"
        />
        </Col>

        <Col md={4} className="project-card">
        <ProjectCard
          isBlog={false}
          logo = {hack}
          title="HackerRank"
          leetcodeLink="https://www.hackerrank.com/profile/CS_2201640100074"
        />
        </Col>

        <Col md={4} className="project-card">
        <ProjectCard
          isBlog={false}
          logo = {github}
          title="GitHub"
          leetcodeLink="https://www.github.com/arpitsharma6074/"
        />
        </Col>

        <Col md={4} className="project-card">
        <ProjectCard
          isBlog={false}
          logo = {unstop}
          title="Unstop"
          leetcodeLink="https://unstop.com/u/arpitsha2444"
        />
        </Col>
    </Row>
  );
}

export default CodingPlateform;
